(function replaceTrademarks() {
  function replaceTextNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace(/\bLEGO(?!®|™)/g, 'LEGO®');
      node.textContent = node.textContent.replace(/\bMinifigure(?!®|™)\b/g, 'Minifigure®');
      node.textContent = node.textContent.replace(/\bMinifigures(?!®|™)\b/g, 'Minifigures®');
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      !['SCRIPT', 'STYLE', 'TEXTAREA'].includes(node.tagName)
    ) {
      node.childNodes.forEach(replaceTextNodes);
    }
  }

  function initTrademarkFix() {
    replaceTextNodes(document.body);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof runWhenIdle === 'function') {
      runWhenIdle(initTrademarkFix);
    } else {
      initTrademarkFix();
    }
  });
})();
